;(function() {
  'use strict'

  angular.module('app.survey').component('surveyCircularChoice', {
    templateUrl: 'survey-circular-choice.html',
    bindings: {
      label: '<',
      btnIcon: '@',
      btnLabel: '@',
      isSelected: '<',
      onClick: '&',
    },
  })
})()
